import React from 'react';
import GoodsPage from "./router/pages/goods";
import Anshlag from "./router/pages/anshlag";
import ConfigPage from "./router/pages/configurator";
import NearHousePlatePage from "./router/pages/near_house_plates";
import AnshlagFull from "./router/pages/anshlag_full";
import PlatesForParking from "./router/pages/plates_for_parking";
import Result from "./router/pages/result";
import BusketRigth from "./router/pages/busket_rigth"
import Busket from "./router/pages/busket/busket_in_order"
import Discount from "./router/pages/discont"

function App() {

  const path = window.location.href

  return (<>
  { path.includes("personal/cart") ? 
      <Busket/>
      : <>
      <GoodsPage />
      {/* <Anshlag />  */}
      {/* <ConfigPage/>
      <NearHousePlatePage />
      <PlatesForParking /> */}
      <AnshlagFull />
      {/* <Result />  */}
      <BusketRigth />
      <Discount />
      </>
  }</>
    
  );
}

export default App;
